
const digest = '78009991b3a6fc410b4b8551f4c06afec9ebeafc6a7524c55f6f1ac3b31a9bd1';
const classes = {"modal":"_modal_1p5vm_1","header":"_header_1p5vm_6","search":"_search_1p5vm_10","layout":"_layout_1p5vm_28","folders":"_folders_1p5vm_35","folderList":"_folderList_1p5vm_44","fileList":"_fileList_1p5vm_45","folder":"_folder_1p5vm_35","folderRoot":"_folderRoot_1p5vm_78","folderSelected":"_folderSelected_1p5vm_86","folderName":"_folderName_1p5vm_97","count":"_count_1p5vm_102","files":"_files_1p5vm_108","filesHead":"_filesHead_1p5vm_114","fileRow":"_fileRow_1p5vm_115","fileRowChecked":"_fileRowChecked_1p5vm_138","fileName":"_fileName_1p5vm_141","checkCol":"_checkCol_1p5vm_145","nameCol":"_nameCol_1p5vm_151","fileTexts":"_fileTexts_1p5vm_159","fileFolder":"_fileFolder_1p5vm_172","dateCol":"_dateCol_1p5vm_177","footer":"_footer_1p5vm_184","note":"_note_1p5vm_188"};
const css = `._modal_1p5vm_1 {
  width: 960px;
  font-family: var(--md-font-family);
}

._header_1p5vm_6 {
  padding-bottom: 18px;
}

._search_1p5vm_10 {
  padding: 0 30px 16px;
}
._search_1p5vm_10 [class*="Input-module_wrapper"] {
  min-height: 46px;
  padding: 0 20px;
  gap: 8px;
  border-radius: 24px;
}
._search_1p5vm_10 [class*="Input-module_prefix"] {
  display: flex;
  color: var(--md-color-label);
}
._search_1p5vm_10 [class*="Input-module_input"] {
  padding: 0;
  font-size: 14px;
}

._layout_1p5vm_28 {
  display: flex;
  height: 440px;
  border-top: 1px solid var(--md-color-border-light);
  border-bottom: 1px solid var(--md-color-border-light);
}

._folders_1p5vm_35 {
  flex-shrink: 0;
  width: 280px;
  padding: 12px 0;
  overflow-y: auto;
  border-right: 1px solid var(--md-color-border-light);
  background: var(--md-color-surface-muted);
}

._folderList_1p5vm_44,
._fileList_1p5vm_45 {
  list-style: none;
  margin: 0;
  padding: 0;
}

._folder_1p5vm_35 {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px 10px 34px;
  border: 0;
  background: transparent;
  font-size: 13px;
  color: var(--md-black);
  text-align: left;
  cursor: pointer;
}
._folder_1p5vm_35 svg {
  flex-shrink: 0;
  color: var(--md-color-primary);
}
._folder_1p5vm_35:hover {
  background: #eef3fc;
}
._folder_1p5vm_35:focus {
  outline: none;
}
._folder_1p5vm_35:focus-visible {
  box-shadow: inset 0 0 0 2px var(--md-color-primary);
}

._folderRoot_1p5vm_78 {
  padding-left: 16px;
  font-weight: 500;
}
._folderRoot_1p5vm_78 svg {
  color: var(--md-color-text-secondary);
}

._folderSelected_1p5vm_86,
._folderSelected_1p5vm_86:hover {
  background: var(--md-color-primary-soft);
  color: var(--md-color-primary-soft-text);
  font-weight: 500;
}
._folderSelected_1p5vm_86 svg,
._folderSelected_1p5vm_86:hover svg {
  color: var(--md-color-primary);
}

._folderName_1p5vm_97 {
  flex: 1;
  min-width: 0;
}

._count_1p5vm_102 {
  font-size: 12px;
  font-weight: 400;
  color: var(--md-color-text-key);
}

._files_1p5vm_108 {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
}

._filesHead_1p5vm_114,
._fileRow_1p5vm_115 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
}

._filesHead_1p5vm_114 {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 20px;
  background: var(--md-color-surface-tab);
  font-size: 12px;
  font-weight: 500;
  color: var(--md-color-text-secondary);
}

._fileRow_1p5vm_115 {
  border-bottom: 1px solid var(--md-color-border-light);
  background: var(--md-white);
}

._fileRowChecked_1p5vm_138 {
  background: #f4f8fe;
}
._fileRowChecked_1p5vm_138 ._fileName_1p5vm_141 {
  font-weight: 500;
}

._checkCol_1p5vm_145 {
  display: flex;
  flex-shrink: 0;
  width: 20px;
}

._nameCol_1p5vm_151 {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

._fileTexts_1p5vm_159 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

._fileName_1p5vm_141 {
  font-size: 14px;
  color: var(--md-black);
  overflow-wrap: anywhere;
}

._fileFolder_1p5vm_172 {
  font-size: 12px;
  color: var(--md-color-text-secondary);
}

._dateCol_1p5vm_177 {
  flex-shrink: 0;
  width: 110px;
  font-size: 13px;
  color: var(--md-color-label);
}

._footer_1p5vm_184 {
  gap: 20px;
}

._note_1p5vm_188 {
  font-size: 13px;
  color: var(--md-color-text-secondary);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  